import React from "react";
import ConnectButton from "./ConnectButton";
import AdminActionsContainer from "./AdminActionsContainer";
import { ClinicManager, Clinic } from "../types/clinic";

interface ClinicProfileProps {
  clinicData: ClinicManager | Clinic | null;
}

const ClinicProfile: React.FC<ClinicProfileProps> = ({ clinicData }) => {
  if (!clinicData) return <p>No clinic profile found.</p>;

  const isClinicManager = (
    data: ClinicManager | Clinic
  ): data is ClinicManager => (data as ClinicManager).clinic !== undefined;

  // const stripeAccountId = isClinicManager(clinicData)
  //   ? clinicData.clinic.stripeAccountId
  //   : clinicData.stripeAccountId;

  return (
    <div className="clinic-profile-container">
      {isClinicManager(clinicData) ? (
        <>
          <h2>Clinic Manager Profile</h2>
          <p>
            <strong>Name:</strong> {clinicData.firstName} {clinicData.lastName}
          </p>
          <p>
            <strong>Email:</strong> {clinicData.user.email}
          </p>
          <p>
            <strong>Joined On:</strong>{" "}
            {new Date(clinicData.createdAt).toLocaleDateString()}
          </p>

          <h2>Clinic Information</h2>
          <p>
            <strong>Clinic Name:</strong> {clinicData.clinic.clinicName}
          </p>
          <p>
            <strong>Address:</strong> {clinicData.clinic.address}
          </p>
          <p>
            <strong>Phone:</strong> {clinicData.clinic.phone}
          </p>
          <p>
            <strong>Region:</strong> {clinicData.clinic.region}
          </p>
          <p>
            <strong>Clinic Code:</strong> {clinicData.clinic.clinicCode}
          </p>
        </>
      ) : (
        <>
          <h2>Clinic Information</h2>
          <p>
            <strong>Clinic Name:</strong> {clinicData.clinicName}
          </p>
          <p>
            <strong>Address:</strong> {clinicData.address}
          </p>
          <p>
            <strong>Phone:</strong> {clinicData.phone}
          </p>
          <p>
            <strong>Region:</strong> {clinicData.region}
          </p>
          <p>
            <strong>Clinic Code:</strong> {clinicData.clinicCode}
          </p>
        </>
      )}

      {isClinicManager(clinicData) && (
        <AdminActionsContainer
          clinicManager={{
            id: clinicData.userId,
            email: clinicData.user.email,
            userId: clinicData.userId,
            firstName: clinicData.firstName,
            lastName: clinicData.lastName,
            phone: clinicData.phone || "",
            createdAt: clinicData.createdAt,
            updatedAt: clinicData.updatedAt,
            user: {
              email: clinicData.user.email,
              role: "CLINIC_MANAGER",
              createdAt: clinicData.user.createdAt,
            },
            clinic: {
              clinicName: clinicData.clinic.clinicName,
              clinicCode: clinicData.clinic.clinicCode,
            },
          }}
        />
      )}
      {/* {stripeAccountId && (
        <ConnectButton connectedAccountId={stripeAccountId} />
      )} */}
    </div>
  );
};

export default ClinicProfile;
